import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useLaunchAnalyseMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
    }: {
      idControleQuinquennal: string;
    }) => ControleQuinquennalApi.launchAnalysis(idControleQuinquennal),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
    },
  });
};
